import React, { useState } from "react";
import passwordIcon from "../Assets/Password.svg";
import passwordIcon2 from "../Assets/Password2.svg";

export function TogglePasswordLogin({ onToggle }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggle = () => {
    setShowPassword(!showPassword);
    onToggle(!showPassword);
  };

  return (
    <div className="password-toggle" onClick={handleToggle}>
      <img
        src={showPassword ? passwordIcon2 : passwordIcon}
        alt=""
        className={
          showPassword
            ? "password-svg-login password-icon-login"
            : "password-svg-login password-icon2-login"
        }
        onClick={handleToggle}
      />
    </div>
  );
}

export function TogglePasswordSignup({ onToggle }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggle = () => {
    setShowPassword(!showPassword);
    onToggle(!showPassword);
  };

  return (
    <div className="password-toggle" onClick={handleToggle}>
      <img
        src={showPassword ? passwordIcon2 : passwordIcon}
        alt=""
        className={
          showPassword
            ? "password-svg-signup password-icon-signup"
            : "password-svg-signup password-icon2-signup"
        }
        onClick={handleToggle}
      />
    </div>
  );
}

export function TogglePasswordReset({ onToggle }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggle = () => {
    setShowPassword(!showPassword);
    onToggle(!showPassword);
  };

  return (
    <div className="password-toggle" onClick={handleToggle}>
      <img
        src={showPassword ? passwordIcon2 : passwordIcon}
        alt=""
        className={
          showPassword
            ? "password-svg-reset password-icon-reset"
            : "password-svg-reset password-icon2-reset"
        }
        onClick={handleToggle}
      />
    </div>
  );
}
